import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
    dialog: {
        position: 'relative'
    },
    dialogTitle: {
        padding: '12px 0 0 24px'
    },
    dialogContent: {
        maxHeight: '400px',
        '& .MuiDialog-paperWidthSm': {
            maxHeight: '400px'
        }
    },
    closeBtn: {
        position: 'absolute',
        right: 0
    },
    note: {
        margin: '12px 0',
        padding: '12px',
        borderRadius: '8px',
        background: '#EFEFEF'
    },
    title: {
        fontWeight: 'bold'
    },
    filesContainer: {
        borderRadius: '12px',
        overflow: 'hidden',
        background: 'white',
        '& div:nth-child(2n)': {
            background: '#F7F7F7',
        },
    },
    fileContainer: {
        padding: ' 4px 12px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    }
}));

export default useStyles;
